import { useEffect } from "react";

import { DeploymentService } from "Api/organizations/projects/environments/deployments/types";
import useGridPoller from "src/organization/pages/project/environment/metrics/resources/grid/useGridPoller";
import PollerGroup from "src/organization/pages/project/environment/metrics/utils/polling/PollerGroup";
import useObservabilityPipelineHttpClient from "src/organization/pages/project/environment/observabilitySandbox/hooks/useObservabilityPipelineHttpClient";

type Props = {
  service: DeploymentService;
  enabled?: boolean;
  pollgroup: PollerGroup;
};

const usePoll = ({ service, enabled = true, pollgroup }: Props) => {
  const client = useObservabilityPipelineHttpClient();

  const { poller, data, ...rest } = useGridPoller({
    serviceName: service.name
  });

  useEffect(() => {
    if (client) {
      pollgroup.registerOnce(service.name, poller, enabled);
    }
  }, [client, enabled, poller, pollgroup, service.name]);

  useEffect(() => {
    return () => {
      pollgroup.unregister(service.name);
    };
  }, [poller, pollgroup, service.name]);

  return { ...data, ...rest };
};

export default usePoll;
